import SharePointSites from './SharePointSites'

export default SharePointSites
